import $ from 'jquery';
import { onScroll, getScrollTop } from '../utils/window';

export default function footer() {
	const $html = $('html');
	const $scroller = $('html, body');

   // const footer = $('#footer');
   // const extra = $html.find('.extra');

   // const extraTitle = extra.find('.container > .title');
   // const extraContent = extra.find('.container > .content');

   // if($('#content .body').hasClass('-last-style-white') || $('#content .body').hasClass('-last-style-light') || $('#content .body').hasClass('-last-style-auto') || $('.body').length == 0) {
   //    extra.addClass('-white');
   //    extraTitle.removeClass('+context-white').removeClass('+context-dark').addClass('+context-white');
   //    extraContent.removeClass('+context-white').removeClass('+context-dark').addClass('+context-dark');
   // } else {
   //    extra.removeClass('-white');
   //    extraTitle.removeClass('+context-white').removeClass('+context-dark').addClass('+context-dark');
   //    extraContent.removeClass('+context-white').removeClass('+context-dark').addClass('+context-dark');
   // }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/footer.js